export default __webpack_public_path__ + "854e34dea983671b12c1779c1d735783.png";